import { useState } from 'react';
import { usePartnerPublicationsContext } from './PartnerPublicationsContext';
import { useQuery } from '@apollo/client';
import {
  GET_PARTNER_DOCUMENTS_QUERY,
  GetPartnerDocumentsOutput,
} from 'graphql/partnerdocuments/PartnerDocumentsQueries';
import { useSelectedLinkContext } from 'contexts';
import PartnerListContainer from './PartnerListContainer';
import { Grid } from '@mui/material';
import { PartnerDocument } from 'types/Partner';
import {
  filterImageDocument,
  sortContentsByPublicationStartDate,
} from 'utils/document';
import PartnerDocumentItem from './PartnerDocument/PartnerDocumentItem';
import { ImageViewerContextProvider } from 'components/medias/ImageViewer/ImageViewerContext';
import { SharedDocument } from 'types/Document';
import ImageViewer from 'components/medias/ImageViewer/ImageViewer';

type PartnerDocumentListPureProps = {
  documents: PartnerDocument[];
};

const PartnerDocumentListPure = ({
  documents,
}: PartnerDocumentListPureProps): JSX.Element => (
  <PartnerListContainer titleMessageId="partner.publications.document.title">
    <Grid container spacing={3}>
      {documents.map((_) => (
        <Grid item key={_.id}>
          <PartnerDocumentItem document={_} />
        </Grid>
      ))}
    </Grid>

    <ImageViewer />
  </PartnerListContainer>
);

const PartnerDocumentList = (): JSX.Element | null => {
  const { selectedLink } = useSelectedLinkContext();
  const { partnerAccount } = usePartnerPublicationsContext();
  const [currentViewedImage, setCurrentViewedImage] =
    useState<SharedDocument>();

  const { data, loading } = useQuery<GetPartnerDocumentsOutput>(
    GET_PARTNER_DOCUMENTS_QUERY,
    {
      variables: {
        getPartnerDocumentsInput: {
          partnerId: partnerAccount.id,
          tabletChannel: selectedLink?.channelKey,
        },
      },
    },
  );

  if (loading) {
    return null;
  }

  const documents = data?.getPartnerDocuments.documents || [];
  const filteredAndSortedDocuments =
    sortContentsByPublicationStartDate<PartnerDocument>(
      documents.filter((document) => !!document.blob?.s3URL),
    );
  const imageDocuments = filterImageDocument(filteredAndSortedDocuments);

  return (
    <ImageViewerContextProvider
      currentViewedImage={currentViewedImage}
      imageDocuments={imageDocuments}
      setCurrentViewedImage={setCurrentViewedImage}
    >
      <PartnerDocumentListPure documents={filteredAndSortedDocuments} />
    </ImageViewerContextProvider>
  );
};

export default PartnerDocumentList;
